import { useEffect, useState } from "react";
import { SignInInput, signInWithRedirect } from "aws-amplify/auth";
import { useAuth } from "src/hook/useContext";
import { BcBackground } from "src/shared/components/Bc-Background/Bc-background";
import { BcAuthMain } from "src/shared/styled/global.styled";
import BcIcon from "src/shared/components/Bc-Icon/Bc-icon";
import { FormDynamic } from "src/shared/interface/form-dynamic";
import { useForm } from "react-hook-form";
import { FormBase } from "src/shared/interface/form-base";
import SwitchFields from "src/shared/components/Bc-SwitchFields/Bc-SwitchFields";
import Microsoft from "../../assets/img/microsoft.svg";
import { Auth } from "src/auth/auth";
import { useLocalStorage } from "src/hook/useLocalStorage";
import { useNavigate } from "react-router-dom";
import { FormLogin } from "src/constants/form";

const Login = () => {
  const { user } = useAuth();
  const [token, setToken] = useLocalStorage("token", null);
  const [userUpt, setUserUpt] = useLocalStorage("user", user);
  const [onlyBank, setOnlyBank] = useState(false);
  const navigate = useNavigate();

  const {
    register,
    unregister,
    setValue,
    handleSubmit,
    getValues,
    watch,
    resetField,
    formState: { errors, touchedFields, dirtyFields, isValid },
  } = useForm({ mode: "onChange" });
  const onSubmit = handleSubmit((data) => {
    Auth.handleSignIn(data as SignInInput)
      .then((r: any) => {
        console.log(r);
        if (r.isSignedIn) {
          userAuth();
        } else {
          navigate("/change-password");
        }
      })
      .catch((error) => {
        console.log("erro component  --->", error);
        setError(true);
        setMsj(error.message);
      });
  });

  const [msj, setMsj] = useState("");
  const [error, setError] = useState(false);
  const [form, setForm] = useState<FormDynamic>(FormLogin);

  console.log(user);

  useEffect(() => {
    setOnlyBank(true);
    setForm(FormLogin);
  }, [])
  

  if (user) {
    window.location.href = "/";
  }

  const handleAzureSignIn = async (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    await signInWithRedirect({
      provider: {
        custom: "Azure",
      },
    });
  };

  const userAuth = async () => {
    const data = await Auth.currentSession();
    const dataUser = await Auth.currentAuthenticatedUser();
    await setToken(data?.idToken);
    await setUserUpt(JSON.stringify(dataUser));
    if (token && userUpt) {
      window.location.href = "/";
    }
  };

  return (
    <BcAuthMain>
      <section className="bc-container bc-card-rounded">
        <BcIcon
          size="bc-2xl"
          ariaLabel="Bancolombia"
          iconName="bancolombia-horizontal"
          addClass="bc-header-brand-logo brand-center"
        />
        <h4 className="msj-error">Herramienta de creación de brief </h4>
        <button
          type="button"
          onClick={handleAzureSignIn}
          className="btn-microsoft"
        >
          {" "}
          <img src={Microsoft} alt="Microsoft" />{" "}
          <span>Iniciar con Microsoft</span>
        </button>
        {onlyBank && (
          <>
            <hr className="bc-hr" />
            <form onSubmit={onSubmit}>
              <h4 className="msj-error">
                Si no eres usuario Bancolombia ingresa aqui:
              </h4>
              {form?.fields &&
                form.fields.map((field: FormBase) => (
                  // eslint-disable-next-line react/jsx-no-undef
                  <SwitchFields
                    key={`login${field.item}`}
                    field={field}
                    errors={errors}
                    register={register}
                    unregister={unregister}
                    setValue={setValue}
                    isRequired={field.isRequired}
                    getValues={getValues}
                    watch={watch}
                    resetField={resetField}
                    isValid={isValid}
                    touchedFields={touchedFields}
                    dirtyFields={dirtyFields}
                  />
                ))}
              {error && <p className="msj-error">{msj}</p>}
              <button
                type="submit"
                className="bc-button-primary bc-button-small"
                disabled={!isValid}
              >
                Iniciar sesión
              </button>
            </form>{" "}
          </>
        )}
      </section>
      <BcBackground />
    </BcAuthMain>
  );
};

export default Login;
